import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { useApi } from "../lib/api";
import { useConfig } from "../lib/use-config";
import { currentSubscription, disablePush, enablePush, isIos, isStandalone, pushSupported } from "../lib/push";

export function SettingsPage() {
  const auth = useAuth();
  const api = useApi();
  const cfg = useConfig();
  const [subscribed, setSubscribed] = useState<boolean | null>(null);
  const [msg, setMsg] = useState<string | null>(null);
  const standalone = isStandalone();

  useEffect(() => {
    void currentSubscription().then((s) => setSubscribed(!!s));
  }, []);

  async function toggle() {
    setMsg(null);
    try {
      if (subscribed) {
        await disablePush(api);
        setSubscribed(false);
      } else {
        await enablePush(api);
        setSubscribed(true);
        setMsg("알림이 켜졌습니다. 처리가 끝나면 알려 드릴게요.");
      }
    } catch (e) {
      setMsg((e as Error).message);
    }
  }

  function logout() {
    void auth.removeUser();
    const url = `${cfg.cognitoDomain}/logout?client_id=${encodeURIComponent(cfg.cognitoClientId)}&logout_uri=${encodeURIComponent(`${window.location.origin}/`)}`;
    window.location.href = url;
  }

  return (
    <div className="px-4 pt-4">
      <h1 className="text-2xl font-bold mb-4">설정</h1>
      <div className="rounded-2xl bg-slate-900 border border-slate-800 p-4 mb-3">
        <p className="text-sm text-slate-400">계정</p>
        <p className="font-medium">{auth.user?.profile.email ?? auth.user?.profile.sub}</p>
      </div>
      <div className="rounded-2xl bg-slate-900 border border-slate-800 p-4 mb-3">
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium">완료 알림 (푸시)</p>
            <p className="text-xs text-slate-400">분석이 끝나면 알림을 보냅니다.</p>
          </div>
          <button className={`tap rounded-full px-4 py-2 text-sm font-semibold ${subscribed ? "bg-slate-700" : "bg-indigo-500"}`} disabled={subscribed === null || !pushSupported()} onClick={() => void toggle()}>
            {subscribed ? "끄기" : "켜기"}
          </button>
        </div>
        {!pushSupported() && isIos() && !standalone && (
          <p className="mt-3 text-xs text-amber-300">iPhone에서는 Safari 공유 버튼 → “홈 화면에 추가”로 설치한 뒤, 설치된 앱에서 알림을 켤 수 있습니다 (iOS 16.4 이상).</p>
        )}
        {!pushSupported() && !isIos() && <p className="mt-3 text-xs text-slate-400">이 브라우저는 푸시 알림을 지원하지 않습니다.</p>}
        {msg && <p className="mt-3 text-xs text-slate-300">{msg}</p>}
      </div>
      {isIos() && !standalone && (
        <div className="rounded-2xl bg-slate-900 border border-slate-800 p-4 mb-3 text-sm">
          <p className="font-medium mb-1">홈 화면에 추가</p>
          <ol className="list-decimal pl-5 text-slate-300 space-y-1 text-xs">
            <li>Safari 하단의 공유 버튼을 누릅니다.</li>
            <li>“홈 화면에 추가”를 선택합니다.</li>
            <li>홈 화면의 ‘회의록’ 아이콘으로 실행합니다.</li>
          </ol>
        </div>
      )}
      <button className="tap mt-6 w-full rounded-xl border border-slate-700 py-3 text-sm" onClick={logout}>로그아웃</button>
      <p className="mt-6 text-center text-[10px] text-slate-600">record.awsbuddy.com · v0.1</p>
    </div>
  );
}
